'use strict';

/**
* @ngdoc controller
* @name tcApp.controllers:PriorityWorkbenchCtrl
* @description
* PWB controller.
*
*/

angular.module('tcApp')
.value('pwbData', null)
.controller('PriorityWorkbenchCtrl', function($scope, $window, pwbData, GlobalService, SystemRouter) {
	if (pwbData != null) {
		$scope.data = pwbData.data;
	}
	if (angular.isUndefined($scope.data)) $scope.data = {};
	$scope.globalStrings = GlobalService.getGlobalStrings();
	$scope.viewModel = {
		pwbHtmlName: 'tc_PWB',
		activeTab: '',
		showTabs: true,
	};
	
	$scope.getDateFrom = function(Html) {
		if (angular.isDefined($scope.data.TabsComponent)) {
			if (Html) {
				return $scope.data.TabsComponent.data.items.DateFromHtml.value;
			} else {
				return $scope.data.TabsComponent.data.items.DateFrom.value;
			}
		}
	};
	
	$scope.getDateTo = function(Html) {
		if (angular.isDefined($scope.data.TabsComponent)) {
			if (Html) {
				return $scope.data.TabsComponent.data.items.DateToHtml.value;
			} else {
				return $scope.data.TabsComponent.data.items.DateTo.value;
			}
		}
	};
	
	$scope.getDate = function(Html) {
		if (angular.isDefined($scope.data.TabsComponent)) {
			if (Html) {
				return $scope.data.TabsComponent.data.items.DateHtml.value;
			} else {
				return $scope.data.TabsComponent.data.items.Date.value;
			}
		}
	};
	
	$scope.getDischDateFrom = function(tabName) {
		if (tabName == 'DISCHPATS') {
			return $scope.getDateFrom();	
		} else if (tabName == 'DUETOM') {
			return $scope.data.tomorrowDate;
		} else {
			return $scope.data.todayDate;	
		}
	};
	
	$scope.getDischDateTo = function(tabName) {
		if (tabName == 'DISCHPATS') {
			return $scope.getDateTo();	
		} else if (tabName == 'DUETOM') {
			return $scope.data.tomorrowDate;
		} else {
			return $scope.data.todayDate;	
		}
	};
	
	$scope.setSelectedTabIndex = function(index) {
		var tabComponentData = $scope.data.TabsComponent.data;
		var tabsData = tabComponentData.items.PriorityWorkbenchTabs.tabData;
		tabsData.selected = index;
	};
	
	$scope.getTabIndexByName = function(tabName) {
		var tabComponentData = $scope.data.TabsComponent.data;
		var tabData = tabComponentData.items.PriorityWorkbenchTabs.tabData;
		var tabIndex = -1;
		angular.forEach(tabData.tabs, function(tab, index) {
			if (tab.name == tabName) {
				tabIndex = index;
			}
		});
		return tabIndex;		
	};
	
	$scope.$on('PWB:selectTab', function(event, tab, compItem, compItemName) {
		var tabName = tab.name;
		if ((tabName == $scope.viewModel.activeTab) || (angular.isUndefined($scope.data[tab.name]))) {
			return;	
		}
		
		var ComponentName = $scope.data[tab.name].componentName;
		var params = '';
		if (angular.isDefined($scope.data[tabName].Context)) {
			params += '&CONTEXT=' + $scope.data[tabName].Context.toUpperCase();
		}
		if (angular.isDefined($scope.data[tabName].ExtraParams)) params += $scope.data[tabName].ExtraParams;
		if (tabName == 'TASKS') {
			params += '&CareProviderDR=' + $scope.data.CPID +  '&DateFrom=' + $scope.getDate(1) + '&DateTo=' + $scope.getDate(1);
		} else if (tabName == 'LINKS') {
			params += '&date=' + $scope.getDate() + '&CPID=' + $scope.data.CPID + '&dateoff=' + $scope.getDateFrom(1) 
				+ '&dateto=' + $scope.getDateTo(1);
		} else if (tabName == 'SCHED') {
			params += '&CPID=' + $scope.data.CPID + '&date=' + $scope.getDate() + '&DateFrom' + $scope.getDate() 
				+ '&CareProviderDR=' + $scope.data.CPID + '&dateoff=' + $scope.getDateFrom(1) + '&dateto=' + $scope.getDateTo(1);
		} else if (tabName == 'NOTES') {
			var NotesID = '';
			if (angular.isDefined($scope.data.TabsComponent)) NotesID = $scope.data.TabsComponent.data.items.NotesID.value;
			params +=  '&ID=' + NotesID + '&date=' + $scope.getDate();
		} else if ((ComponentName == 'EPVisitNumber.OrderingCP.List') 
				|| (ComponentName == 'EPVisitNumber.ReviewDueAlerts.List')) {
			params += '&CareProvID=' + $scope.data.CPID + '&DateFrom=' + $scope.getDateFrom()  
				+ '&DateTo=' + $scope.getDateTo();	
		} else if (ComponentName == 'PAAdmDischargeCP.List') {
			params += '&CareProvID=' + $scope.data.CPID + '&DateFrom=' + $scope.getDischDateFrom(tabName) 
				+ '&DateTo=' + $scope.getDischDateTo(tabName);	
		}
		$scope.selectPWBTab(tab, compItemName, params);
	});
	
	$scope.selectPWBTab = function(tab, compItemName, params) {
		var ComponentName = $scope.data[tab.name].componentName;
		var uniqueIndexPrefix = (compItemName + (tab.index - 1));
		SystemRouter.fetchComponentData(ComponentName, params, undefined, uniqueIndexPrefix)
			.then(function(response) {
				$scope.data[tab.name].data = response.data;
				$scope.viewModel.activeTab = tab.name;
				GlobalService.updateButtonBar($scope.isButtonBarShown());
			});		
	};
	
	$scope.isButtonBarShown = function() {
		var buttonBarShown = $scope.data.TabsComponent.data.componentHasButtons;
		// if not buttons on tabs component, check activeTab component
		if (($scope.viewModel.activeTab != '') && (!buttonBarShown)) {
			var activeComponentData = $scope.data[$scope.viewModel.activeTab].data;
			var activeTabHasButtons = activeComponentData.componentHasButtons;
			// if no buttons on parent, check any nested components
			if ((activeComponentData.hasNestedComponentItems) && (!activeTabHasButtons)) {
				angular.forEach(activeComponentData.items, function(item) {
					if ((angular.isDefined(item.displayType)) && (item.displayType === 'CX')
						&& angular.isDefined(item.componentData)) {
						activeTabHasButtons = ((activeTabHasButtons) || (item.componentData.componentHasButtons));
					}
				});
			}
			return activeTabHasButtons;
		}
		return buttonBarShown;
	};
	
	$scope.$on('PWB:linkSelected', function(event, tabName) {
		var tabIndex = $scope.getTabIndexByName(tabName);
		if (tabIndex >= 0) {
			$scope.setSelectedTabIndex(tabIndex);
		} else {
			event.preventDefault();	
		}
	});
	
	$scope.$on('PWB:reload', function(event, params) {
		var paramsObj = GlobalService.urlToObject(params);
		$scope.viewModel.activeTab = '';
		$scope.viewModel.showTabs = false;
		SystemRouter.fetchPWBData(paramsObj)
		.then(function(response) {
			$scope.data = response.data;
			$scope.viewModel.showTabs = true;	
		});
	});
	
	$scope.$on('Global:userLogon', function(event, sessionData) {
		$scope.globalStrings = sessionData.globalStrings;
	});

});
